module.exports = __webpack_public_path__ + "img/i_error.6514966a.svg";